import { ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from '../../../../services/data.service';
import { IceapiService } from '../../../../services/index';
import { CalculationType } from '../../enums/calculation-type.enum';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DiagramDataModel, DiagramInfo, DimensionOverridesInput, EngineeredJointInputData, ProcessInfoData, SubHeaderData, TighteningData } from '../../models';
import { CalculationResult, InputGroup, ToolOutput } from '../../models/calculationModels/index';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { TranslocoService } from '@jsverse/transloco';
@Component({
    selector: 'app-engineered-joint',
    templateUrl: './engineered-joint.component.html',
    styleUrls: ['./engineered-joint.component.scss'],
    standalone: false
})
export class EngineeredJointComponent implements OnInit, OnDestroy {
    @Input() cssClass: '';
    @ViewChild('panel1') panel1;
    @ViewChild('panel2') panel2;
    @ViewChild('panel3') panel3;
    @ViewChild('beginbtn', { static: false }) beginbtn: ElementRef;
    destroy$ = new Subject();

    subHeaderData: SubHeaderData;
    engJointInput: InputGroup;
    calculationResult: CalculationResult;
    diagramInfo: DiagramDataModel;
    toolsData: ToolOutput[];
    isInitialFormLoad: boolean = true;
    isInputValid: boolean = false;
    isTighteningInputValid: boolean = false;
    isEngJointInputValid: boolean = false;
    outputTabIndex = 0;
    selectedTool: ToolOutput;
    tooltip_position = 'above';
    tighteningform = false;
    enggJointform = false;
    toolsform = false;
    showpaneltoggle = false;
    showPanelUnitToggle = false;
    editpanel_1 = false;
    editpanel_2 = false;
    editpanel_3 = false;
    hideAdvanceOptionTab: boolean = false;
    isRedirect: string = 'false';
    engineerJointInputFormGroup: UntypedFormGroup;
    tighteningProcedureForm: UntypedFormGroup;
    toolsFormGroup: UntypedFormGroup;
    LoadCalculationSubscription: Subscription;
    IsCalculationOutPutTabSelected: boolean = false;

    isCalculationDone: boolean;
    isTighFormValid: boolean = false;
    isEngiFormValid: boolean = false;

    constructor(
        private iceapi: IceapiService,
        private renderer: Renderer2,
        private route: ActivatedRoute,
        private dataSvc: DataService,
        private router: Router,
        private cd: ChangeDetectorRef,
        private ngxUiLoaderService: NgxUiLoaderService,
        private globalEmittersService: GlobalEmittersService,
        private user_utility: UserUtilityService,
                 private translocoService: TranslocoService
    ) {
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    }

    ngOnInit() {
        this.subHeaderData = this.setSubHeaderValues();
        this.engJointInput = new InputGroup();
        this.diagramInfo = new DiagramDataModel();

        this.route.params.pipe(takeUntil(this.destroy$)).subscribe((params) => {
            this.isRedirect = params['isRedirect'];
        });
        if (this.isRedirect == 'true') {
            this.ngxUiLoaderService.start();
            this.calculationResult = this.dataSvc?.calculationData;
            this.engJointInput = this.dataSvc?.calculationData?.input;
            this.toolsData = this.dataSvc?.calculationData?.output?.tools;
            this.isInitialFormLoad = false;
            this.editpanel_1 = true;
            this.editpanel_2 = true;
            this.editpanel_3 = true;
            this.tighteningform = true;
            this.enggJointform = true;
            this.toolsform = true;
            this.ngxUiLoaderService.stop();
            this.isCalculationDone = true;
            this.globalEmittersService.isCalculationHappen.next(true); // * this is used for tools component to display conditional based warning
        } else {
            this.engJointInput = new InputGroup();
            this.dataSvc.calculationData = null;
            this.globalEmittersService.isCalculationHappen.next(false); // * this is used for tools component to display conditional based warning
        }

        this.globalEmittersService.currentCalculationType.next(CalculationType.EngineeredJoint);

        this.globalEmittersService.openControlProcedurePanel.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            if (res) {
                this.showPanel1And2();
            }
        });

        this.globalEmittersService.engineerJointIFormGroup.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            this.engineerJointInputFormGroup = res;
            res?.valueChanges?.pipe(takeUntil(this.destroy$)).subscribe((val) => {
                if (val && this.isCalculationDone) {
                    this.isEngiFormValid = false;
                }
            });
        });

        this.globalEmittersService.tighteningProcedureForm.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            this.tighteningProcedureForm = res;
            res?.valueChanges?.pipe(takeUntil(this.destroy$)).subscribe((val) => {
                if (val && this.isCalculationDone) {
                    this.isTighFormValid = false;
                }
            });
        });
        this.globalEmittersService.toolsFormGroup.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            this.toolsFormGroup = res;
        });

        this.LoadCalculationSubscription = this.globalEmittersService.LoadCalculation.pipe(takeUntil(this.destroy$)).subscribe((data: boolean) => {
            if (data) {
                this.btnCalculateClicked();
                if (this.selectedTool) {
                    this.globalEmittersService.ManufactureName.next(this.selectedTool.manufacturer.name);
                    this.globalEmittersService.ToolSelectedId.next(this.selectedTool.id);
                    this.IsCalculationOutPutTabSelected = true;
                }
            }
        });

        this.globalEmittersService.isCalculationHappen.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            if (res) {
                this.hideAdvanceOption();
            }
        });
    }

    hideAdvanceOption(): void {
        if (this.calculationResult?.output) {
            this.hideAdvanceOptionTab = true;
        }
        if (this.calculationResult?.output?.general?.warnings) {
            let res = this.calculationResult.output.general.warnings.some((w) => w.severity <= 1);
            if (res === true) {
                this.hideAdvanceOptionTab = false;
            }
        }
    }

    setSubHeaderValues(): SubHeaderData {
        let headerData = new SubHeaderData();
        headerData.displayText = this.translocoService.translate('HOME_PAGE.HEADER.INFORMATE_DROPDOWN.LINK.ENGINEERED_JOINT');
        headerData.disableActions = true;
        headerData.defaultImageSrc = '../../../../../../assets/media/logos/engineered-black-button.png';
        headerData.mouseOverImageSrc = '../../../../../../assets/media/logos/engineered-yellow-button.png';
        return headerData;
    }

    tighteningDataHandler(tighteningData: TighteningData) {
        if (tighteningData.isDataValid) {
            this.engJointInput.others.tighteningMethod = tighteningData.tighteningMethod;
            this.engJointInput.others.breakout = tighteningData.breakout;
            this.engJointInput.others.percentageCover = tighteningData.percentageCover;
            this.engJointInput.others.lubricantMode = tighteningData.lubricantMode;
            this.engJointInput.recordId.lubricantId = tighteningData.lubricantId;
            this.engJointInput.calculationOverrides.kFactor = tighteningData.kFactor;
            this.isTighteningInputValid = true;
            this.isTighFormValid = true;
        } else {
            this.isTighteningInputValid = false;
        }
        if (!this.editpanel_1) {
            this.panel2.open();
        }
        this.editpanel_1 = true;
        this.tighteningform = false;
        this.panel1.close();
        this.setValidity();
    }

    engJointDataHandler(engJointInputData: EngineeredJointInputData) {
        if (engJointInputData.isDataValid) {
            this.engJointInput.others.jointConfiguration = engJointInputData.jointConfiguration;
            engJointInputData?.isRedAreaBoltSelected
                ? (this.engJointInput.calculationOverrides.minimumBoltDiameter = engJointInputData?.minimumBoltDiameter)
                : (this.engJointInput.calculationOverrides.minimumBoltDiameter = undefined);
            this.engJointInput.dimensionOverrides = new DimensionOverridesInput();
            engJointInputData?.isRedAreaBoltSelected
                ? (this.engJointInput.dimensionOverrides.reducedAreaBolting = engJointInputData?.minimumBoltDiameter)
                : (this.engJointInput.dimensionOverrides.reducedAreaBolting = undefined);

            this.engJointInput.calculationOverrides.jointThickness = engJointInputData.jointThickness;
            this.engJointInput.calculationOverrides.boltHoleDiameter = engJointInputData.boltHoleDiameter;
            this.engJointInput.calculationOverrides.gasketCompThickness = engJointInputData.gasketCompThickness;
            this.engJointInput.calculationOverrides.pAdditional = engJointInputData.pAdditional;

            this.engJointInput.others.threadType = engJointInputData.threadType;
            this.engJointInput.others.boltType = engJointInputData.boltType;
            this.engJointInput.others.boltQuantity = engJointInputData.boltQuantity;
            this.engJointInput.recordId.boltDimensionId = engJointInputData.boltDimensionId;
            this.engJointInput.recordId.nutDimensionId = engJointInputData.nutDimensionId;

            this.engJointInput.others.tighteningSpecification = engJointInputData.tighteningSpecification;
            this.engJointInput.others.tighteningSpecificationInput = engJointInputData.tighteningSpecificationInput;
            this.engJointInput.recordId.flangeMaterialId1 = engJointInputData.flangeMaterialId1;
            this.engJointInput.recordId.flangeMaterialId2 = engJointInputData.flangeMaterialId2;
            this.engJointInput.recordId.gasketId = engJointInputData.gasketId;
            this.engJointInput.recordId.boltMaterialId = engJointInputData.boltMaterialId;
            this.engJointInput.recordId.boltMaterialAliasId = engJointInputData.boltMaterialAliasId==undefined || engJointInputData.boltMaterialAliasId==null || engJointInputData.boltMaterialAliasId=='' ? null: engJointInputData.boltMaterialAliasId;       
            this.engJointInput.recordId.flangeMaterialAliasId1 =engJointInputData.flangeMaterialAliasId1==undefined || engJointInputData.flangeMaterialAliasId1==null || engJointInputData.flangeMaterialAliasId1=='' ? null:engJointInputData.flangeMaterialAliasId1;  
            this.engJointInput.recordId.flangeMaterialAliasId2 = engJointInputData.flangeMaterialAliasId2==undefined || engJointInputData.flangeMaterialAliasId2==null || engJointInputData.flangeMaterialAliasId2=='' ? null: engJointInputData.flangeMaterialAliasId2;              
            this.engJointInput.recordId.gasketAliasId = engJointInputData.gasketAliasId==undefined || engJointInputData.gasketAliasId==null || engJointInputData.gasketAliasId=='' ? null:engJointInputData.gasketAliasId;            
         
            this.isEngJointInputValid = true;
            this.isEngiFormValid = true;
        } else {
            this.isEngJointInputValid = false;
        }
        if (!this.editpanel_2) {
            this.panel3.open();
        }
        this.editpanel_2 = true;
        this.enggJointform = false;
        this.panel2.close();
        this.setValidity();
    }

    processInfoDataHandler(processInfoData: ProcessInfoData) {
        this.engJointInput.calculationOverrides.operatingTemperature = processInfoData.operatingTemperature;
        this.engJointInput.calculationOverrides.operatingPressure = processInfoData.operatingPressure;
        this.engJointInput.calculationOverrides.testPressure = processInfoData.testPressure;
        if (this.isTighteningInputValid && this.isEngJointInputValid) {
            this.engJointInput.calculationOverrides.distanceToNearestObstruction = '1000 mm';
            this.invokeCalculate(this.engJointInput)
                .then(() => {
                    this.ngxUiLoaderService.stop();
                    this.iceapi.calculationRes.next(true);
                })
                .catch(() => {
                    this.ngxUiLoaderService.stop();
                });
        }
    }

    toolsDataHandler(nearestObstruction: string) {
        this.engJointInput.calculationOverrides.distanceToNearestObstruction = nearestObstruction;
    }

    selectedToolDataHandler(selectedToolId: string) {
        this.calculationResult.output.tools.forEach((x) => (x.isSelected = false));
        this.calculationResult.output.tools.find((x) => x.id === selectedToolId).isSelected = true;
        this.selectedTool = this.calculationResult.output.tools.find((x) => x.id === selectedToolId);
        this.dataSvc.selectedToolId = selectedToolId;
        this.outputTabIndex = 1;
    }

    async invokeCalculate(inputGroup: InputGroup) {
        await this.iceapi
            .postCalculateEngineeredJoint(inputGroup)
            .toPromise()
            .then((res) => {
                if (res.success === true) {
                    if (!this.editpanel_2) {
                        this.panel3.open();
                    }
                    this.editpanel_2 = true;
                    // this.panel2.close();
                    this.tighteningform = false;
                    this.enggJointform = false;
                    this.calculationResult = res.response;
                    if (res.response.calculationSucceeded) {
                        this.iceapi.calculationRes.next(true);
                        this.globalEmittersService.isCalculationHappen.next(true); // * this is used for tools component to display conditional based warning
                        this.toolsData = this.calculationResult.output.tools;
                        this.engJointInput.calculationOverrides.minimumBoltDiameter = undefined;
                        if (!this.toolsData.length) {
                            this.outputTabIndex = 1;
                        }
                        this.subHeaderData.disableActions = false;
                        this.outputTabIndex = 0;

                        if (this.IsCalculationOutPutTabSelected) {
                            this.outputTabIndex = 1;
                        }
                    } else {
                        this.globalEmittersService.isCalculationHappen.next(false);
                    }
                    this.cd.markForCheck();
                } else {
                    this.globalEmittersService.isCalculationHappen.next(false);
                    this.user_utility.errorModelPopup(res.message);
                }
            })
            .catch(() => {
                this.ngxUiLoaderService.stop();
            });
    }

    diagramDataHandler(diagramInfo: DiagramInfo) {
        switch (diagramInfo.diagramType) {
            case 'EngineeredJoint':
                this.diagramInfo.isDiagramsAdded = true;
                this.diagramInfo.engineeredJoint = diagramInfo;
                break;
            case 'Tool Image':
                this.diagramInfo.toolImage = diagramInfo;
                break;
            case 'Tool Diagram':
                this.diagramInfo.tool = diagramInfo;
                break;
        }
    }

    btnCalculateClicked() {
        this.globalEmittersService.refreshWarnings.next(true);
        if (this.isInputValid || this.isRedirect == 'true') {
            this.ngxUiLoaderService.start();
            this.engJointInput.calculationType = CalculationType.EngineeredJoint;
            if (!this.engJointInput.calculationOverrides.distanceToNearestObstruction) {
                this.engJointInput.calculationOverrides.distanceToNearestObstruction = '1000 mm';
            }
            this.invokeCalculate(this.engJointInput)
                .then(() => {
                    this.ngxUiLoaderService.stop();
                    this.isCalculationDone = true;
                })
                .catch(() => {
                    this.ngxUiLoaderService.stop();
                });
        }
    }

    setValidity() {
        if (this.isTighteningInputValid && this.isEngJointInputValid) {
            this.isInputValid = true;
        } else {
            this.isInputValid = false;
        }
    }

    beginform() {
        this.isInitialFormLoad = false;
        this.tighteningform = true;
        this.enggJointform = false;
        this.toolsform = false;
        this.renderer.addClass(this.beginbtn.nativeElement, 'active');
    }

    showPanel1() {
        if (this.editpanel_1 == true) this.tighteningform = true;
        this.enggJointform = false;
        this.toolsform = false;
    }

    showPanel2() {
        if (this.tighteningProcedureForm.valid) {
            this.tighteningform = false;
            this.enggJointform = true;
            this.toolsform = false;
        }
    }
    showPanel3() {
        if (this.engineerJointInputFormGroup.valid) {
            this.tighteningform = false;
            this.enggJointform = false;
            this.toolsform = true;
        }
    }

    showpanel() {
        this.showpaneltoggle = !this.showpaneltoggle;
    }

    showPanel1And2() {
        this.tighteningform = true;
        this.enggJointform = true;
        this.toolsform = false;
    }

    hidepanelclose() {
        this.showpaneltoggle = false;
    }

    showUnitpanel() {
        this.showPanelUnitToggle = !this.showPanelUnitToggle;
    }

    hideUnitpanelClose() {
        this.showPanelUnitToggle = false;
    }
    ngOnDestroy(): void {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
